/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { KeysOf } from "#app/composables/asyncData";
import { isMocked, mockPath } from "#root/api/util/mocking";
import type { ApiOptions, UseApiOptions } from "../http-client";
import { HttpClient } from "../http-client";
import type {
  AzContestGenerateTokenData,
  AzContestInvalidateTokenData,
  AzContestInvalidateTokenPayload,
  AzContestUploadImageData,
  AzContestUploadImagePayload,
  AzContestValidateTokenData,
  AzContestValidateTokenPayload,
  CheckAzContestVoterData,
  CloudinaryUploadData,
  CloudinaryUploadPayload,
  GetAzContestImagesData,
  GetCollectionsData,
  GetFooterData,
  GetFootSizesData,
  GetLocalesData,
  GetSearchHubData,
  GetSizeChartData,
  GetStaticPageData,
  GetUtilityData,
  RemoveAzContestVoteData,
  VoteAzContestImageData,
  VoteAzContestImagePayload,
} from "./data-contracts";

export class Internal extends HttpClient {
  static paths = {
    azContestGenerateToken: "/fapi/az-contest/generate-token",
    azContestValidateToken: "/fapi/az-contest/validate-token",
    azContestInvalidateToken: "/fapi/az-contest/invalidate-token",
    getCollections: "/fapi/components/collections",
    cloudinaryUpload: "/fapi/cloudinary/upload",
    azContestUploadImage: "/fapi/az-contest/upload",
    getAzContestImages: "/fapi/az-contest/images",
    checkAzContestVoter: "/fapi/az-contest/check-voter",
    voteAzContestImage: "/fapi/az-contest/vote",
    removeAzContestVote: "/fapi/az-contest/remove-vote",
    getFooter: "/fapi/components/footer",
    getFootSizes: "/fapi/components/foot-sizes",
    getSearchHub: "/fapi/components/search-hub",
    getSizeChart: "/fapi/components/size-chart/:productType",
    getUtility: "/fapi/components/utility",
    getLocales: "/fapi/pages/location-selector",
    getStaticPage: "/fapi/pages/:page",
  };
  static mockDataPaths = {};
  static mockedPaths = {
    azContestGenerateToken: false,
    azContestValidateToken: false,
    azContestInvalidateToken: false,
    getCollections: false,
    cloudinaryUpload: false,
    azContestUploadImage: false,
    getAzContestImages: false,
    checkAzContestVoter: false,
    voteAzContestImage: false,
    removeAzContestVote: false,
    getFooter: false,
    getFootSizes: false,
    getSearchHub: false,
    getSizeChart: false,
    getUtility: false,
    getLocales: false,
    getStaticPage: false,
  };
  static onResponseHandlers = {};
  constructor(baseParams) {
    super(baseParams, "Api");
  }

  /**
   * No description
   *
   * @tags Internal
   * @name AzContestGenerateToken
   * @summary Generate AZ Contest Token
   * @request GET:/fapi/az-contest/generate-token
   */
  azContestGenerateToken = <
    ResT = AzContestGenerateTokenData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/az-contest/generate-token")
        ? computed(() => mockPath("Internal", "azContestGenerateToken", ``))
        : computed(() => `/fapi/az-contest/generate-token`),
      method: "GET",
      format: "json",
      key: `/fapi/az-contest/generate-token`,
      apiName: "Internal.azContestGenerateToken",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name AzContestGenerateToken
   * @summary Generate AZ Contest Token
   * @request GET:/fapi/az-contest/generate-token
   */
  $azContestGenerateToken = (requestParams: ApiOptions = {}) =>
    this.$request<AzContestGenerateTokenData>({
      path: isMocked("/fapi/az-contest/generate-token")
        ? mockPath("Internal", "azContestGenerateToken", ``)
        : `/fapi/az-contest/generate-token`,
      method: "GET",
      format: "json",
      apiName: "Internal.azContestGenerateToken",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name AzContestValidateToken
   * @summary Validate AZ Contest Token
   * @request POST:/fapi/az-contest/validate-token
   */
  azContestValidateToken = <
    ResT = AzContestValidateTokenData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: AzContestValidateTokenPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/az-contest/validate-token")
        ? computed(() => mockPath("Internal", "azContestValidateToken", ``))
        : computed(() => `/fapi/az-contest/validate-token`),
      method: "POST",
      body: data,
      format: "json",
      key: `/fapi/az-contest/validate-token`,
      apiName: "Internal.azContestValidateToken",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name AzContestValidateToken
   * @summary Validate AZ Contest Token
   * @request POST:/fapi/az-contest/validate-token
   */
  $azContestValidateToken = (
    data: AzContestValidateTokenPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<AzContestValidateTokenData>({
      path: isMocked("/fapi/az-contest/validate-token")
        ? mockPath("Internal", "azContestValidateToken", ``)
        : `/fapi/az-contest/validate-token`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Internal.azContestValidateToken",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name AzContestInvalidateToken
   * @summary Invalidate AZ Contest Token
   * @request POST:/fapi/az-contest/invalidate-token
   */
  azContestInvalidateToken = <
    ResT = AzContestInvalidateTokenData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: AzContestInvalidateTokenPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/az-contest/invalidate-token")
        ? computed(() => mockPath("Internal", "azContestInvalidateToken", ``))
        : computed(() => `/fapi/az-contest/invalidate-token`),
      method: "POST",
      body: data,
      format: "json",
      key: `/fapi/az-contest/invalidate-token`,
      apiName: "Internal.azContestInvalidateToken",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name AzContestInvalidateToken
   * @summary Invalidate AZ Contest Token
   * @request POST:/fapi/az-contest/invalidate-token
   */
  $azContestInvalidateToken = (
    data: AzContestInvalidateTokenPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<AzContestInvalidateTokenData>({
      path: isMocked("/fapi/az-contest/invalidate-token")
        ? mockPath("Internal", "azContestInvalidateToken", ``)
        : `/fapi/az-contest/invalidate-token`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Internal.azContestInvalidateToken",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetCollections
   * @summary Get Mega Menu Collections Data
   * @request GET:/fapi/components/collections
   */
  getCollections = <
    ResT = GetCollectionsData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/components/collections")
        ? computed(() => mockPath("Internal", "getCollections", ``))
        : computed(() => `/fapi/components/collections`),
      method: "GET",
      format: "json",
      key: `/fapi/components/collections`,
      apiName: "Internal.getCollections",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetCollections
   * @summary Get Mega Menu Collections Data
   * @request GET:/fapi/components/collections
   */
  $getCollections = (requestParams: ApiOptions = {}) =>
    this.$request<GetCollectionsData>({
      path: isMocked("/fapi/components/collections")
        ? mockPath("Internal", "getCollections", ``)
        : `/fapi/components/collections`,
      method: "GET",
      format: "json",
      apiName: "Internal.getCollections",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name CloudinaryUpload
   * @summary Upload a file to Cloudinary
   * @request POST:/fapi/cloudinary/upload
   */
  cloudinaryUpload = <
    ResT = CloudinaryUploadData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: CloudinaryUploadPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/cloudinary/upload")
        ? computed(() => mockPath("Internal", "cloudinaryUpload", ``))
        : computed(() => `/fapi/cloudinary/upload`),
      method: "POST",
      body: data,
      format: "json",
      key: `/fapi/cloudinary/upload`,
      apiName: "Internal.cloudinaryUpload",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name CloudinaryUpload
   * @summary Upload a file to Cloudinary
   * @request POST:/fapi/cloudinary/upload
   */
  $cloudinaryUpload = (
    data: CloudinaryUploadPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<CloudinaryUploadData>({
      path: isMocked("/fapi/cloudinary/upload")
        ? mockPath("Internal", "cloudinaryUpload", ``)
        : `/fapi/cloudinary/upload`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Internal.cloudinaryUpload",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name AzContestUploadImage
   * @summary Submit Image
   * @request POST:/fapi/az-contest/upload
   */
  azContestUploadImage = <
    ResT = AzContestUploadImageData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: AzContestUploadImagePayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/az-contest/upload")
        ? computed(() => mockPath("Internal", "azContestUploadImage", ``))
        : computed(() => `/fapi/az-contest/upload`),
      method: "POST",
      body: data,
      format: "json",
      key: `/fapi/az-contest/upload`,
      apiName: "Internal.azContestUploadImage",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name AzContestUploadImage
   * @summary Submit Image
   * @request POST:/fapi/az-contest/upload
   */
  $azContestUploadImage = (
    data: AzContestUploadImagePayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<AzContestUploadImageData>({
      path: isMocked("/fapi/az-contest/upload")
        ? mockPath("Internal", "azContestUploadImage", ``)
        : `/fapi/az-contest/upload`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Internal.azContestUploadImage",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetAzContestImages
   * @summary Get AZ Contest Images
   * @request GET:/fapi/az-contest/images
   */
  getAzContestImages = <
    ResT = GetAzContestImagesData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/az-contest/images")
        ? computed(() => mockPath("Internal", "getAzContestImages", ``))
        : computed(() => `/fapi/az-contest/images`),
      method: "GET",
      format: "json",
      key: `/fapi/az-contest/images`,
      apiName: "Internal.getAzContestImages",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetAzContestImages
   * @summary Get AZ Contest Images
   * @request GET:/fapi/az-contest/images
   */
  $getAzContestImages = (requestParams: ApiOptions = {}) =>
    this.$request<GetAzContestImagesData>({
      path: isMocked("/fapi/az-contest/images")
        ? mockPath("Internal", "getAzContestImages", ``)
        : `/fapi/az-contest/images`,
      method: "GET",
      format: "json",
      apiName: "Internal.getAzContestImages",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name CheckAzContestVoter
   * @summary Check AZ Contest Voter Status
   * @request GET:/fapi/az-contest/check-voter
   */
  checkAzContestVoter = <
    ResT = CheckAzContestVoterData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    query: {
      consumerId: string;
    },
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/az-contest/check-voter")
        ? computed(() => mockPath("Internal", "checkAzContestVoter", ``))
        : computed(() => `/fapi/az-contest/check-voter`),
      method: "GET",
      query: query,
      format: "json",
      key: `/fapi/az-contest/check-voter`,
      apiName: "Internal.checkAzContestVoter",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name CheckAzContestVoter
   * @summary Check AZ Contest Voter Status
   * @request GET:/fapi/az-contest/check-voter
   */
  $checkAzContestVoter = (
    query: {
      consumerId: string;
    },
    requestParams: ApiOptions = {},
  ) =>
    this.$request<CheckAzContestVoterData>({
      path: isMocked("/fapi/az-contest/check-voter")
        ? mockPath("Internal", "checkAzContestVoter", ``)
        : `/fapi/az-contest/check-voter`,
      method: "GET",
      query: query,
      format: "json",
      apiName: "Internal.checkAzContestVoter",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name VoteAzContestImage
   * @summary Vote for an AZ Contest Image
   * @request POST:/fapi/az-contest/vote
   */
  voteAzContestImage = <
    ResT = VoteAzContestImageData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: VoteAzContestImagePayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/az-contest/vote")
        ? computed(() => mockPath("Internal", "voteAzContestImage", ``))
        : computed(() => `/fapi/az-contest/vote`),
      method: "POST",
      body: data,
      format: "json",
      key: `/fapi/az-contest/vote`,
      apiName: "Internal.voteAzContestImage",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name VoteAzContestImage
   * @summary Vote for an AZ Contest Image
   * @request POST:/fapi/az-contest/vote
   */
  $voteAzContestImage = (
    data: VoteAzContestImagePayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<VoteAzContestImageData>({
      path: isMocked("/fapi/az-contest/vote")
        ? mockPath("Internal", "voteAzContestImage", ``)
        : `/fapi/az-contest/vote`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Internal.voteAzContestImage",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name RemoveAzContestVote
   * @summary Remove vote from an AZ Contest Image
   * @request POST:/fapi/az-contest/remove-vote
   */
  removeAzContestVote = <
    ResT = RemoveAzContestVoteData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: any,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/az-contest/remove-vote")
        ? computed(() => mockPath("Internal", "removeAzContestVote", ``))
        : computed(() => `/fapi/az-contest/remove-vote`),
      method: "POST",
      body: data,
      format: "json",
      key: `/fapi/az-contest/remove-vote`,
      apiName: "Internal.removeAzContestVote",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name RemoveAzContestVote
   * @summary Remove vote from an AZ Contest Image
   * @request POST:/fapi/az-contest/remove-vote
   */
  $removeAzContestVote = (data: any, requestParams: ApiOptions = {}) =>
    this.$request<RemoveAzContestVoteData>({
      path: isMocked("/fapi/az-contest/remove-vote")
        ? mockPath("Internal", "removeAzContestVote", ``)
        : `/fapi/az-contest/remove-vote`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Internal.removeAzContestVote",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetFooter
   * @summary Get Footer Data
   * @request GET:/fapi/components/footer
   */
  getFooter = <
    ResT = GetFooterData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/components/footer")
        ? computed(() => mockPath("Internal", "getFooter", ``))
        : computed(() => `/fapi/components/footer`),
      method: "GET",
      format: "json",
      key: `/fapi/components/footer`,
      apiName: "Internal.getFooter",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetFooter
   * @summary Get Footer Data
   * @request GET:/fapi/components/footer
   */
  $getFooter = (requestParams: ApiOptions = {}) =>
    this.$request<GetFooterData>({
      path: isMocked("/fapi/components/footer")
        ? mockPath("Internal", "getFooter", ``)
        : `/fapi/components/footer`,
      method: "GET",
      format: "json",
      apiName: "Internal.getFooter",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetFootSizes
   * @summary Get Foot Sizes Data
   * @request GET:/fapi/components/foot-sizes
   */
  getFootSizes = <
    ResT = GetFootSizesData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/components/foot-sizes")
        ? computed(() => mockPath("Internal", "getFootSizes", ``))
        : computed(() => `/fapi/components/foot-sizes`),
      method: "GET",
      format: "json",
      key: `/fapi/components/foot-sizes`,
      apiName: "Internal.getFootSizes",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetFootSizes
   * @summary Get Foot Sizes Data
   * @request GET:/fapi/components/foot-sizes
   */
  $getFootSizes = (requestParams: ApiOptions = {}) =>
    this.$request<GetFootSizesData>({
      path: isMocked("/fapi/components/foot-sizes")
        ? mockPath("Internal", "getFootSizes", ``)
        : `/fapi/components/foot-sizes`,
      method: "GET",
      format: "json",
      apiName: "Internal.getFootSizes",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetSearchHub
   * @summary Get Search Hub Data
   * @request GET:/fapi/components/search-hub
   */
  getSearchHub = <
    ResT = GetSearchHubData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/components/search-hub")
        ? computed(() => mockPath("Internal", "getSearchHub", ``))
        : computed(() => `/fapi/components/search-hub`),
      method: "GET",
      format: "json",
      key: `/fapi/components/search-hub`,
      apiName: "Internal.getSearchHub",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetSearchHub
   * @summary Get Search Hub Data
   * @request GET:/fapi/components/search-hub
   */
  $getSearchHub = (requestParams: ApiOptions = {}) =>
    this.$request<GetSearchHubData>({
      path: isMocked("/fapi/components/search-hub")
        ? mockPath("Internal", "getSearchHub", ``)
        : `/fapi/components/search-hub`,
      method: "GET",
      format: "json",
      apiName: "Internal.getSearchHub",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetSizeChart
   * @summary Get Size Chart Data
   * @request GET:/fapi/components/size-chart/{productType}
   */
  getSizeChart = <
    ResT = GetSizeChartData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    productType: MaybeRefOrGetter<string>,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/components/size-chart/:productType")
        ? computed(() =>
            mockPath(
              "Internal",
              "getSizeChart",
              `productType:${toValue(productType)}`,
            ),
          )
        : computed(() => `/fapi/components/size-chart/${toValue(productType)}`),
      method: "GET",
      format: "json",
      key: `/fapi/components/size-chart/${toValue(productType)}`,
      apiName: "Internal.getSizeChart",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetSizeChart
   * @summary Get Size Chart Data
   * @request GET:/fapi/components/size-chart/{productType}
   */
  $getSizeChart = (productType: string, requestParams: ApiOptions = {}) =>
    this.$request<GetSizeChartData>({
      path: isMocked("/fapi/components/size-chart/:productType")
        ? mockPath(
            "Internal",
            "getSizeChart",
            `productType:${toValue(productType)}`,
          )
        : `/fapi/components/size-chart/${productType}`,
      method: "GET",
      format: "json",
      apiName: "Internal.getSizeChart",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetUtility
   * @summary Get Utility Navigation Data
   * @request GET:/fapi/components/utility
   */
  getUtility = <
    ResT = GetUtilityData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/components/utility")
        ? computed(() => mockPath("Internal", "getUtility", ``))
        : computed(() => `/fapi/components/utility`),
      method: "GET",
      format: "json",
      key: `/fapi/components/utility`,
      apiName: "Internal.getUtility",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetUtility
   * @summary Get Utility Navigation Data
   * @request GET:/fapi/components/utility
   */
  $getUtility = (requestParams: ApiOptions = {}) =>
    this.$request<GetUtilityData>({
      path: isMocked("/fapi/components/utility")
        ? mockPath("Internal", "getUtility", ``)
        : `/fapi/components/utility`,
      method: "GET",
      format: "json",
      apiName: "Internal.getUtility",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetLocales
   * @summary Get Locales Data
   * @request GET:/fapi/pages/location-selector
   */
  getLocales = <
    ResT = GetLocalesData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/pages/location-selector")
        ? computed(() => mockPath("Internal", "getLocales", ``))
        : computed(() => `/fapi/pages/location-selector`),
      method: "GET",
      format: "json",
      key: `/fapi/pages/location-selector`,
      apiName: "Internal.getLocales",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetLocales
   * @summary Get Locales Data
   * @request GET:/fapi/pages/location-selector
   */
  $getLocales = (requestParams: ApiOptions = {}) =>
    this.$request<GetLocalesData>({
      path: isMocked("/fapi/pages/location-selector")
        ? mockPath("Internal", "getLocales", ``)
        : `/fapi/pages/location-selector`,
      method: "GET",
      format: "json",
      apiName: "Internal.getLocales",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetStaticPage
   * @summary Get Static Page Data
   * @request GET:/fapi/pages/{page}
   */
  getStaticPage = <
    ResT = GetStaticPageData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    page: MaybeRefOrGetter<string>,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/fapi/pages/:page")
        ? computed(() =>
            mockPath("Internal", "getStaticPage", `page:${toValue(page)}`),
          )
        : computed(() => `/fapi/pages/${toValue(page)}`),
      method: "GET",
      format: "json",
      key: `/fapi/pages/${toValue(page)}`,
      apiName: "Internal.getStaticPage",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Internal
   * @name GetStaticPage
   * @summary Get Static Page Data
   * @request GET:/fapi/pages/{page}
   */
  $getStaticPage = (page: string, requestParams: ApiOptions = {}) =>
    this.$request<GetStaticPageData>({
      path: isMocked("/fapi/pages/:page")
        ? mockPath("Internal", "getStaticPage", `page:${toValue(page)}`)
        : `/fapi/pages/${page}`,
      method: "GET",
      format: "json",
      apiName: "Internal.getStaticPage",
      mobileAppTracking: "false",
      ...requestParams,
    });
}
